import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, input, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ItemListForFilters } from '../models/item-list-for-filters.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'modern-select',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, TranslateModule],
  templateUrl: './modern-select.component.html',
  styleUrl: './modern-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ModernSelectComponent),
      multi: true,
    },
  ],
})
export class ModernSelectComponent implements ControlValueAccessor {
  placeHolder = input<string>('');
  autoSelectFirst = input<boolean>(false);
  placementDropDown = input<string[]>(['bottom-start', 'bottom-end', 'top-start', 'top-end']);
  protected itemsForSelect = signal<ItemListForFilters[]>([]);
  protected selectedPlaceHolder = input<string>(this.translateService.instant('Select a value...'));
  protected currentItemSelected = signal<ItemListForFilters | undefined>(undefined);

  private onChange: any;
  private onTouch: any;

  constructor(private translateService: TranslateService) {}

  @Input() set items(items: ItemListForFilters[]) {
    this.itemsForSelect.set(items);
    if (this.autoSelectFirst() && items.length) {
      this.select(items[0]);
    }
  }

  writeValue(value: ItemListForFilters | any) {
    this.currentItemSelected.set(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  protected select(item: ItemListForFilters) {
    this.onChange?.(item);
    this.currentItemSelected.set(item);
  }
}
